
interface ContentCardProps {
  content: {
    id: string;
    title: string;
    photographer: string;
    city: string;
    price: number;
    views: number;
    downloads: number;
    category: string;
    imageUrl?: string;
    previewUrl?: string;
    thumbnailUrl?: string;
    duration?: string;
  };
  onClick?: () => void;
}

export default function ContentCard({ content, onClick }: ContentCardProps) {
  const isVideo = 'duration' in content;
  const imageUrl = isVideo ? content.thumbnailUrl : (content.previewUrl || content.imageUrl);

  return (
    <div 
      className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer group"
      onClick={onClick}
    >
      <div className="relative">
        <img
          src={imageUrl}
          alt={content.title}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
          style={{ userSelect: 'none' }}
          onContextMenu={(e) => e.preventDefault()}
          draggable={false}
        />
        {isVideo && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/20">
            <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
              <i className="ri-play-fill text-[#1C1C1C] text-xl w-5 h-5 flex items-center justify-center mr-1"></i>
            </div>
          </div>
        )}
        {isVideo && (
          <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
            {content.duration}
          </div>
        )}
        <div className="absolute top-2 left-2 bg-[#D4AF37] text-white text-sm px-2 py-1 rounded-full font-semibold">
          {content.price} ريال
        </div>
      </div>
      
      <div className="p-4">
        <h3 className="font-semibold text-[#1C1C1C] mb-2 group-hover:text-[#D4AF37] transition-colors">
          {content.title}
        </h3>
        <p className="text-sm text-gray-600 mb-3">
          بواسطة {content.photographer} • {content.city}
        </p>
        
        <div className="flex items-center justify-between text-xs text-gray-500">
          <div className="flex items-center">
            <i className="ri-eye-line ml-1 w-3 h-3 flex items-center justify-center"></i>
            {content.views.toLocaleString()}
          </div>
          <div className="flex items-center">
            <i className="ri-download-line ml-1 w-3 h-3 flex items-center justify-center"></i>
            {content.downloads}
          </div>
        </div>
      </div>
    </div>
  );
}
